import React from 'react';
import { CategoryInfoDTO } from '../../../api/useSurveyResultsQuery';
import { Box, BoxProps } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { CategoryScore } from '../CategoryScore/CategoryScore';
import { LargeCopy } from '../../Output.styles';
import { Lozenge } from '../../../../CommonComponents/OPL/Lozenge/Lozenge';

interface IndividualCategoryProps extends BoxProps {
  label: string;
  description: string;
  primaryRespondentScore: number;
  categoryInfo: CategoryInfoDTO;
}

export const IndividualCategory = ({
  label,
  description,
  primaryRespondentScore,
  categoryInfo,
  ...rest
}: IndividualCategoryProps) => {
  return (
    <Box {...rest}>
      <Lozenge mb="16">{label}</Lozenge>

      <Text fontSize="h3" fontWeight={600} color="neutral.800" mb="16">
        {categoryInfo[label].header}
      </Text>

      <CategoryScore
        primaryRespondentScore={primaryRespondentScore}
        leftComparison={categoryInfo[label].low}
        rightComparison={categoryInfo[label].high}
      />

      <LargeCopy mt="8">{description}</LargeCopy>
    </Box>
  );
};
